import { FieldType } from '@wix/wix-data-schema-types'
import {
  IMAGE_ROLE,
  IMAGE_ROLE_SRC_SUBROLE,
  IMAGE_ROLE_SRC_AND_LINK_SUBROLE,
  IMAGE_ROLE_LINK_SUBROLE,
  IMAGE_ROLE_DEFAULT_SUBROLE,
} from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

const {
  text,
  email,
  date,
  dateTime,
  number,
  url,
  stringArray,
  document,
  video,
  address,
  image,
} = FieldType

export default (): DataBindingComponentModel => ({
  componentName: 'Element_Name_Image',
  isConnectGfppEnabled: true,
  supportsDefaultSelectedDataset: true,
  compactErrorPanel: false,
  panel: {
    height: 528,
    title: 'CONNECT_PANEL_TITLE_IMAGE',
    helpId: 'd7cd3e7b-6702-4613-9197-bf580cd560d9',
  },
  sections: [
    {
      role: IMAGE_ROLE,
      bindings: [
        {
          title: 'Connect_Panel_Connect_Image_Label',
          prop: 'src',
          supportedFieldTypes: [image],
          defaultFieldType: image,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
        },
        {
          title: 'Connect_Panel_Connect_Alttext_Label',
          prop: 'alt',
          supportedFieldTypes: [
            text,
            email,
            number,
            date,
            dateTime,
            address,
            stringArray,
          ],
          defaultFieldType: text,
          supportsReferenceFields: true,
        },
        {
          title: 'Connect_Panel_Connect_Link_Label',
          prop: 'link',
          supportedFieldTypes: [document, url, image, video],
          defaultFieldType: url,
          event: 'onClick',
          supportPageLinks: true,
          supportsActions: true,
          supportsReferenceFields: true,
          supportsPostSubmit: true,
          supportsUrlTarget: true,
          supportsUrlRel: true,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId: 'image_live_preview_gfpp_desktop_main_action',
              label: 'Image_Live_Preview_GFPP_Desktop_Main_Action',
            },
            mainAction2: 'HIDE' as const,
          },
        },
      },
      subroles: [
        {
          name: IMAGE_ROLE_SRC_AND_LINK_SUBROLE,
          conditions: [
            { connectedProps: [{ prop: 'src' }, { prop: 'link' }] },
            {
              connectedProps: [{ prop: 'src' }],
              connectedEvents: [{ event: 'onClick' as const }],
            },
          ],
          manifest: {
            gfpp: {
              desktop: {
                iconButtons: {
                  link: {
                    behavior: 'HIDE' as const,
                  },
                },
              },
            },
          },
        },
        {
          name: IMAGE_ROLE_SRC_SUBROLE,
          conditions: [{ connectedProps: [{ prop: 'src' }] }],
          manifest: {},
        },
        {
          name: IMAGE_ROLE_LINK_SUBROLE,
          conditions: [
            { connectedProps: [{ prop: 'link' }] },
            { connectedEvents: [{ event: 'onClick' as const }] },
          ],
          manifest: {
            gfpp: {
              desktop: {
                mainAction1: 'DEFAULT1' as const,
                mainAction2: 'DEFAULT2' as const,
                iconButtons: {
                  link: {
                    behavior: 'HIDE' as const,
                  },
                },
              },
            },
          },
        },
        {
          name: IMAGE_ROLE_DEFAULT_SUBROLE,
          conditions: [{}],
          manifest: {
            gfpp: {
              desktop: {
                mainAction1: 'DEFAULT1' as const,
                mainAction2: 'DEFAULT2' as const,
              },
            },
          },
        },
      ],
    },
  ],
})
